import script from "./SkillCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SkillCard.vue?vue&type=script&setup=true&lang=js"

import "./SkillCard.vue?vue&type=style&index=0&id=1f042c50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f042c50"]])

export default __exports__